/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Knp_Terms_Deleted_Terms_SuccessInputs */



/**
* | output |
* | --- |
* | "Deleted {count} term(s) successfully" |
*
* @param {Knp_Terms_Deleted_Terms_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_deleted_terms_success = /** @type {((inputs: Knp_Terms_Deleted_Terms_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Deleted_Terms_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Suppression réussie de ${i?.count} terme(s)`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Term(e) erfolgreich gelöscht`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Eliminati correttamente ${i?.count} termini`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Термин(ы) ${i?.count} успешно удален(ы).`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Se eliminaron ${i?.count} términos correctamente`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已成功删除 ${i?.count} 术语`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} 個の用語を削除しました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} पद सफलतापूर्वक हटा दिए गए`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Termo(s) ${i?.count} excluído(s) com sucesso`)
	return /** @type {LocalizedString} */ (`Deleted ${i?.count} term(s) successfully`)
});